import { Component, OnInit, OnDestroy, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { AuthService } from 'src/app/services/auth.service';
import { UtilsService } from 'src/app/services/utils.service';
import { Subscription } from 'rxjs';
import { ResponseService } from 'src/app/interfaces/response';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-activate-account-form',
  templateUrl: './activate-account-form.component.html',
  styleUrls: ['./activate-account-form.component.scss'],
})
export class ActivateAccountFormComponent implements OnInit, OnDestroy {
  constructor(
    private router: Router,
    private fb: UntypedFormBuilder,
    private forgot: AuthService,
    private utils: UtilsService
  ) {}

  text: any = '';
  emailPattern = '[A-Z0-9a-z._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,64}';
  activateForm: UntypedFormGroup;
  private subscription: Subscription = new Subscription();

  swalOptInvalid: object = {
    title: this.text,
    confirmButtonText: 'Aceptar',
    confirmButtonClass: 'button-base button-base__cancel',
    type: 'error',
  };

  swalOptError: object = {
    title: 'Ups algo salió mal',
    text: this.text,
    confirmButtonText: 'Aceptar',
    confirmButtonClass: 'button-base button-base__cancel',
    type: 'error',
  };

  swalOptSuccess: object = {
    title: 'Se ha enviado un email',
    text: this.text,
    confirmButtonText: 'Aceptar',
    confirmButtonClass: 'button-base button-base__cancel',
    type: 'success',
  };

  ngOnInit() {
    this.activateForm = this.fb.group({
      email: ['', [Validators.required, Validators.pattern(this.emailPattern), Validators.maxLength(64)]],
    });
  }

  @HostListener('over')
  hideActivate() {
    this.utils.showloginForm();
  }

  /**
   * Metodo para enviar correo cuando se olvido la contreña
   * @param email  recibe el nombre del usuario que es el correo.
   */

  public activateAccount() {
    const email = this.activateForm.controls.email.value;
    this.subscription = this.forgot.sendActivation(email).subscribe(
      (resp: ResponseService) => {
        if (resp.state === 'Success') {
          this.swalOptSuccess = {
            ...this.swalOptSuccess,
            text: resp.userMessage,
          };
          Swal.fire(this.swalOptSuccess).then(() => {
            this.utils.hideloginForm();
          });
        } else {
          Swal.fire(
            (this.swalOptError = {
              ...this.swalOptError,
              text: resp.userMessage,
            })
          );
        }
      },
      (error) => {
        Swal.fire(
          (this.swalOptInvalid = {
            ...this.swalOptInvalid,
            text: error.statusText,
          })
        );
      }
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
